import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table for casino report view.
 */
export default class recordTableCasinoReportView extends JetView {
    /**
     * Configures the UI components for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Historial'), align: 'center' }, // Title label
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close window on icon click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails',
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                select: true,
                columns: [
                    {
                        id: 'detailTittle',
                        header: '',
                        width: 50,
                        height: 25,
                        tooltip: _('Detalles'), // Tooltip for details column
                        template: function (obj) {
                            return "<span class='webix_icon wxi-close details'></span><span class='webix_icon icon-cancel cancel'></span>"; // Template for detail icons
                        },
                    },
                    { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // Column for Id
                    {
                        id: 'TransactionId',
                        header: _('Transacción Id'), // Localized header for Transaction Id
                        width: 300,
                        sort: 'int',
                    },
                    { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Localized header for Type
                    {
                        id: 'Amount',
                        header: _('Valor'), // Localized header for Amount
                        width: 100,
                        format: webix.i18n.priceFormat, // Formatting for price
                        exportType: 'number',
                        sort: 'int',
                    },
                ],
                onClick: {
                    details: function (euv, id) {
                        var item = this.getItem(id); // Get the clicked item
                        vthis.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
                        $$('detailsCasino').show(); // Show details view
                    },
                    cancel: function (euv, id) {
                        var vthis = this; // Reference to the current context
                        webix.confirm({
                            type: 'confirm-warning',
                            text: _('Advertencia!') + '<br/>' + _('Desea Cancelar la transacción manualmente ? '), // Confirmation message
                            ok: _('Cancelar transacción'), // Confirm button text
                            cancel: _('Salir'), // Cancel button text
                            callback: function (action) {
                                if (action === true) {
                                    var item = vthis.getItem(id); // Get the item to cancel
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for AJAX request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Report/CancelCasinoDetail',
                                            '{ "Id":' + item.Id + '}', // Payload for cancellation
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    data = JSON.parse(text); // Parse response
                                                    if (!data.HasError) {
                                                        webix.message(
                                                            _('Transaccion Cancelada'), // Success message
                                                        );
                                                        vthis.$scope.app.callEvent('casinoDetail:reload', []); // Reload event
                                                    } else {
                                                        webix.message({
                                                            text: _(data.AlertMessage),
                                                            title: '¡Error!',
                                                            type: 'alert-error', // Error message type
                                                        });
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        });
                    },
                },
            },
        });

        return {
            view: 'datatable',
            id: 'datatableDetail',
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true,
            columns: [
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: _('Detalles'), // Tooltip for details column
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close details'></span><span class='webix_icon icon-cancel cancel'></span>"; // Template for detail icons
                    },
                },
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // Column for Id
                {
                    id: 'TransactionId',
                    header: _('Transacción Id'), // Localized header for Transaction Id
                    width: 300,
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Localized header for Type
                {
                    id: 'Amount',
                    header: _('Valor'), // Localized header for Amount
                    width: 100,
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number',
                    sort: 'int',
                },
            ],
            onClick: {
                details: function (euv, id) {
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
                },
                cancel: function (euv, id) {
                    var vthis = this; // Reference to the current context
                    webix.confirm({
                        type: 'confirm-warning',
                        text: _('Advertencia!') + '<br/>' + _('Desea Cancelar la transacción manualmente ? '), // Confirmation message
                        ok: _('Cancelar transacción'), // Confirm button text
                        cancel: _('Salir'), // Cancel button text
                        callback: function (action) {
                            if (action === true) {
                                var item = vthis.getItem(id); // Get the item to cancel
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json', // Set content type for AJAX request
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Report/CancelCasinoDetail',
                                        '{ "Id":' + item.Id + '}', // Payload for cancellation
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message(_('Error! ')); // Show error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                data = JSON.parse(text); // Parse response
                                                if (!data.HasError) {
                                                    webix.message(
                                                        _('Transaccion Cancelada'), // Success message
                                                    );
                                                    vthis.$scope.app.callEvent('casinoDetail:reload', []); // Reload event
                                                } else {
                                                    webix.message({
                                                        text: _(data.AlertMessage),
                                                        title: '¡Error!',
                                                        type: 'alert-error', // Error message type
                                                    });
                                                }
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
            },
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            tooltip: true, // Enable tooltips
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'null/Report/GetCasinoGamesReportDetail'; // API URL for fetching report details
        var idP = 0; // Placeholder for user ID

        // Event listener for user ID changes
        this.on(this.app, 'user:id', (idUser) => {
            idP = idUser; // Update user ID
            grid.clearAll(); // Clear grid data
            grid.load(url + '?id=' + idUser); // Load grid data for the user
            $$('dtDetails').clearAll(); // Clear details data
            $$('dtDetails').load(url + '?id=' + idUser); // Load details data for the user
        });

        // Event listener for reloading casino details
        this.on(this.app, 'casinoDetail:reload', (idUser) => {
            grid.clearAll(); // Clear grid data
            grid.load(url + '?id=' + idP); // Load grid data for the stored user ID
            $$('dtDetails').clearAll(); // Clear details data
            $$('dtDetails').load(url + '?id=' + idP); // Load details data for the stored user ID
        });

        // Event listener for item clicks in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
